import { useState } from "react";
import { IscrizioniView } from "@/pages/MensaMatricePage";
import ExtraAlunniView from "@/pages/ExtraAlunniView";
import ExtraIscrizioniCronoView from "@/pages/ExtraIscrizioniCronoView";
import ExtraGiorniCorsiView from "@/pages/ExtraGiorniCorsiView";

export default function ExtraIscrizioniPage() {
  const [tab, setTab] = useState("log");
  const [pendingCorsoFilter, setPendingCorsoFilter] = useState(null);
  return (
    <div>
      <div style={{ margin: "8px 20px 0", display: "flex", gap: 2, borderBottom: "2px solid #c62828", flexWrap: "wrap" }}>
        <TabBtn active={tab === "log"} onClick={() => setTab("log")} testid="extra-tab-log-iscrizioni" color="#6a1b9a">🕒 Log iscrizioni</TabBtn>
        <TabBtn active={tab === "corsi-alunni"} onClick={() => setTab("corsi-alunni")} testid="extra-tab-corsi-alunni" color="#c62828">📋 Corsi ›› Alunni</TabBtn>
        <TabBtn active={tab === "alunni-corsi"} onClick={() => setTab("alunni-corsi")} testid="extra-tab-alunni-corsi" color="#1565c0">👥 Alunni ›› Corsi</TabBtn>
        <TabBtn active={tab === "giorni-corsi"} onClick={() => setTab("giorni-corsi")} testid="extra-tab-giorni-corsi" color="#6a1b9a">🗓 Giorni Corsi</TabBtn>
      </div>
      {tab === "log" && (
        <ExtraIscrizioniCronoView
          onNewIscrizione={() => {
            try { sessionStorage.setItem("extra_open_wizard", "1"); } catch { /* ignore */ }
            setTab("corsi-alunni");
          }}
          onOpenCorso={(corsoCodice, anno) => {
            // 🆕 Reindirizza a "Corsi ›› Alunni" filtrando sul corso richiesto
            try {
              sessionStorage.setItem("extra_focus_corso", corsoCodice || "");
              if (anno != null) sessionStorage.setItem("extra_focus_anno", String(anno));
            } catch { /* ignore */ }
            setPendingCorsoFilter({ corso: corsoCodice, anno });
            setTab("corsi-alunni");
          }}
        />
      )}
      {tab === "corsi-alunni" && <IscrizioniView kind="extra" initialFocus={pendingCorsoFilter} />}
      {tab === "alunni-corsi" && <ExtraAlunniView />}
      {tab === "giorni-corsi" && <ExtraGiorniCorsiView />}
    </div>
  );
}

function TabBtn({ active, onClick, children, testid, color = "#1565c0" }) {
  return (
    <button data-testid={testid} onClick={onClick}
      style={{ padding: "8px 18px", border: "none", background: active ? color : "white", color: active ? "white" : color,
        fontWeight: 700, fontSize: 12, cursor: "pointer", borderRadius: "4px 4px 0 0", borderTop: "1px solid #ccc", borderLeft: "1px solid #ccc", borderRight: "1px solid #ccc" }}>
      {children}
    </button>
  );
}
